import { useEffect, useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";

export default function BlogDetailPage({ data }) {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const updateScroll = () => {
      const totalHeight = document.body.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener("scroll", updateScroll);
    return () => window.removeEventListener("scroll", updateScroll);
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="min-h-screen font-sans">
      <div
        className="fixed top-0 left-0 z-50 h-1 bg-indigo-600"
        style={{ width: `${scrollProgress}%` }}
      />

      <main className="mx-auto max-w-4xl px-4 py-8">
        <h1 className="mb-4 text-3xl font-bold text-gray-800">{data.title}</h1>

        <div className="mb-6 flex flex-wrap gap-4 text-sm text-gray-600">
          <div className="flex items-center gap-1">
            <FaCalendarAlt size={16} />
            <span>{formatDate(data.createdAt)}</span>
          </div>
        </div>

        <div className="mb-8 overflow-hidden rounded-xl shadow-lg">
          <img
            src={data.featureImg}
            alt={data.title}
            className="h-auto w-full object-cover"
            loading="eager"
            decoding="async"
          />
          <div className="bg-gray-100 p-2 text-sm italic text-gray-500">
            {data.metaTags?.ogDescription}
          </div>
        </div>

        <article>
          <div
            className="mb-6 leading-relaxed text-gray-700"
            dangerouslySetInnerHTML={{ __html: data.description }}
          />
        </article>
      </main>
    </div>
  );
}
